<template>
  <div class="pa-10">
    <StudentDataTable />
  </div>
</template>

<script>
import StudentDataTable from "../../components/Utils/StudentDataTable.vue";
export default {
  name: "StudentPage",
  components: {
    StudentDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
